import Home from "./pages/Home";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Dashboard from "./pages/Dashboard";
import About from "./pages/About";
import Support from "./pages/Support";

import AppContext from "./component/dashboard/common/context/AppContext";
import { ActivityProvider } from "./context/ActivityContext";

function App() {
  return (
    <BrowserRouter>
      <ActivityProvider>
        <AppContext>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/start-now" element={<Dashboard />} />
            <Route path="/about" element={<About />} />
            <Route path="/support" element={<Support />} />
          </Routes>
        </AppContext>
      </ActivityProvider>
    </BrowserRouter>
  );
}

export default App;
